<template>
  <div class="datepicker" v-if="format === 'DD-MM-YYYY' || format === 'DD-MM'">
    <day-picker
      :current-date="currentDate"
      :format="format"
      @change="selectDate"
      @change-picker="changePicker"
      @select-date="selectDate"
      v-show="picker === 'day'"
    />
    <month-picker
      :current-date="currentDate"
      format="MMM"
      @change-picker="changePicker"
      @select-month="selectMonth"
      @select-year="selectYear"
      showYearHeader
      v-show="picker === 'month'"
    />
    <year-picker
      :current-date="currentDate"
      :format="format"
      @change-picker="changePicker"
      @select-year="selectYear"
      v-show="picker === 'year'"
    />
  </div>
  <div class="datepicker" v-else-if="format === 'MM'">
    <month-picker
      :current-date="currentDate"
      :format="format"
      @select-month="selectMonth"
      @select-year="selectYear"
      v-show="picker === 'month'"
    />
    <year-picker :current-date="currentDate" :format="format" @select-year="selectYear" v-show="picker === 'year'" />
  </div>
  <div class="datepicker" v-else-if="format === 'YYYY'">
    <year-picker :current-date="currentDate" :format="format" @select-year="selectYear" v-show="picker === 'year'" />
  </div>
</template>

<script>
import DayPicker from './DayPicker.vue'
import MonthPicker from './MonthPicker.vue'
import YearPicker from './YearPicker.vue'
import moment from 'moment'

export default {
  name: 'DatePicker',
  components: { DayPicker, MonthPicker, YearPicker },
  props: {
    dateProp: String | Number,
    format: {
      type: String,
      default: 'DD-MM-YYYY'
    }
  },
  data() {
    return {
      picker: 'day',
      currentDate: moment()
    }
  },
  created() {
    if (this.format === 'MM') {
      this.picker = 'month'
    } else if (this.format === 'YYYY') {
      this.picker = 'year'
    } else {
      this.picker = 'day'
    }
  },
  methods: {
    changePicker(picker) {
      this.picker = picker
    },
    selectDate(selectedDate) {
      this.currentDate = selectedDate
      this.$emit('change', this.currentDate)
    },
    selectMonth(selectedMonth) {
      this.currentDate = moment(this.currentDate).month(isNaN(selectedMonth) ? selectedMonth : selectedMonth - 1)

      if (this.format === 'MM') {
        this.$emit('change', this.currentDate.startOf('month'))
      }
    },
    selectYear(selectedYear) {
      this.currentDate = moment(this.currentDate).year(selectedYear)

      if (this.format === 'YYYY') {
        this.$emit('change', this.currentDate.startOf('year'))
      }
    }
  },
  watch: {
    dateProp: function(date) {
      date = moment(date, this.format)

      if (date.isValid()) {
        this.currentDate = moment(date)
      }
    }
  }
}
</script>
